import { fromLocaleDate } from "@/helpers/dateHelper";
import { CalculatePriceResponse } from "@/models/api/CalculatePriceResponse";
import { UserResponse } from "@/models/api/UserResponse";
import { BookingSummary } from "@/models/www/store/BookingSummary";
import { Customer, Agent, User } from "@/models/www/store/User";
import { NewBookingResponse } from "@/models/api/NewBookingResponse";
import { UserType } from "@/models/enums";
import baseApi from "./api.service";
import { SearchBookingsRequest } from "@/models/api/SearchBookingsRequest";

const accountService = {
    isAgentLoggedIn(): Promise<boolean> {
        return baseApi.get<boolean>("agent/loggedin");
    },
    isCustomerLoggedIn(): Promise<boolean> {
        return baseApi.get<boolean>("customer/loggedin");
    },
    getBookings(req: SearchBookingsRequest): Promise<BookingSummary[]> {
        return new Promise((resolve, reject) => {
            baseApi.post<CalculatePriceResponse[]>(`user/bookings/`, req)
                .then(resp => resolve(resp.map(b => new BookingSummary(b))))
                .catch(err => reject(err))
        })
    },

    getUser(): Promise<User> {

        return new Promise((resolve, reject) => {
            baseApi.get<UserResponse>("user").then(resp => {
                resolve(resp.type == UserType[UserType.Customer] ? new Customer(resp) : new Agent(resp))
            }).catch(err => reject(err));
        })
    },
    updateCustomer(user: Customer): Promise<void> {
        return baseApi.post<void>("customer", { ...user, dateOfBirth: fromLocaleDate(user.dateOfBirth as string) });
    },
    updatePassword(password: string): Promise<void> {
        return baseApi.post<void>("customer/password", { password });
    },
    updateNewsletter(subscribe: boolean): Promise<void> {
        return baseApi.post("customer/newsletter", { newsletter: subscribe });
    },
    newBooking() : Promise<string> {
    		return new Promise((resolve, reject) => {
    				baseApi.post<NewBookingResponse>("booking/new", {})
    					.then((resp) => {
    						resolve(resp.redirectUrl);
    				})
    				.catch((err) => {
    						reject(err);
    				});
    			});
    }
}

export default accountService;